/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M5.9292 7.5854c-.471-.2758-1.073-.1114-1.3443.3671-.2715.4786-.1096 1.09.3614 1.3657l5.5693 3.2597v6.3216c0 .5522.4407.9999.9844.9999.5436 0 .9843-.4477.9843-.9999v-6.3216l5.5693-3.2597c.471-.2757.6329-.8871.3615-1.3657-.2715-.4785-.8734-.6429-1.3444-.3671L11.5 10.846 5.9292 7.5853Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.1793.362a2.5897 2.5897 0 0 1 2.6414 0l7.875 4.6572C21.5032 5.4967 22 6.3744 22 7.3236v9.3528c0 .9492-.4968 1.8268-1.3043 2.3044l-7.875 4.6571a2.5896 2.5896 0 0 1-2.6414 0l-7.875-4.6571C1.4968 18.5033 1 17.6256 1 16.6764V7.3236c0-.9492.4968-1.8269 1.3043-2.3044L10.1793.362Zm1.6509 1.7284 7.875 4.6571c.2019.1194.3261.3388.3261.5761v9.3528c0 .2373-.1242.4567-.3261.5761l-7.875 4.6571a.6475.6475 0 0 1-.6604 0l-7.875-4.6571c-.2019-.1194-.326-.3388-.326-.5761V7.3236c0-.2373.1241-.4567.326-.576l7.875-4.6572a.6475.6475 0 0 1 .6604 0Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuProject'
);
